import { BASE_URL, CAL_URL } from "../../configs/WebServiceUrl";

export const getClasses = `${CAL_URL}/api/classes`;

export const getSubjects = `${CAL_URL}/api/subjects/link/`;

export const chapters = `${CAL_URL}/api/chapters`;

export const getQuestionTypes = `${CAL_URL}/api/subjects/question-types`;

export const questions = `${BASE_URL}/api/questions`;

export const uploadImage = `${BASE_URL}/api/upload-image`;

export const getDifficultyLevels = `${CAL_URL}/api/subjects/difficulty-levels`;
export const bulkUpload = `${questions}/bulk-upload`;

export const upload = `${BASE_URL}/api/upload`;

export const getClassesNew = `${BASE_URL}/api/timetable/classes/1`;
